// // import React, { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   doc,
// //   collection,
// //   getDocs,
// //   deleteDoc,
// //   getDoc,
// //   updateDoc
// // } from "firebase/firestore";
// // import { db } from "../firebase";
// // import "./SevakListGroup.css"; // Importing custom styles
// // import generateGroupPDF from "./GroupMembersPDF"; // Adjust path as needed
// // import { Button } from "react-bootstrap"; // Using React Bootstrap
// // import { getAuth, onAuthStateChanged } from "firebase/auth";

// // import { query, where } from "firebase/firestore";

// // const SevakListGroup = () => {
// //   const [groups, setGroups] = useState([]);
// //   const navigate = useNavigate();
// //   const [showModal, setShowModal] = useState(false);
// //   const [selectedGroup, setSelectedGroup] = useState(null);
// //   const [confirmInput, setConfirmInput] = useState("");
// //   const [user, setUser] = useState(null);

// //   const [showEditModal, setShowEditModal] = useState(false);
// //   const [confirmEditInput, setConfirmEditInput] = useState("");
// //   const [editGroupData, setEditGroupData] = useState({
// //     groupName: "",
// //     location: "",
// //     mobile: "",
// //   });



// //   useEffect(() => {
// //     const auth = getAuth();
// //     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
// //       if (currentUser) {
// //         setUser(currentUser);
// //       } else {
// //         setUser(null);
// //       }
// //     });

// //     return () => unsubscribe();
// //   }, []);


// //   useEffect(() => {
// //     const fetchGroups = async () => {
// //       if (!user) return;

// //       try {
// //         const groupsRef = collection(db, "sevakGroups");
// //         let q;

// //         if (user.role?.toLowerCase() === "admin") {
// //           // Admin: fetch all groups
// //           q = query(groupsRef);
// //         } else {
// //           // Non-admin: fetch groups created by this user
// //           q = query(groupsRef, where("createdBy.uid", "==", user.uid));
// //         }

// //         const querySnapshot = await getDocs(q);

// //         const groupList = querySnapshot.docs.map((doc) => {
// //           const data = doc.data();
// //           const leader = data.members?.find(
// //             (m) => m.designation?.toLowerCase() === "leader"
// //           );
// //           return {
// //             id: doc.id,
// //             groupId: data.accountId || data.groupId,
// //             groupName: data.groupName,
// //             station: data.station,
// //             leaderName: leader?.name || data.leaderName || "Not Assigned",
// //             leaderMobile: leader?.mobile || data.mobile || "-",
// //             totalMembers: data.members?.length || 0,
// //           };
// //         });

// //         setGroups(groupList);
// //       } catch (error) {
// //         console.error("Error fetching groups:", error);
// //       }
// //     };

// //     fetchGroups();
// //   }, [user]);

// //   const handleGroupClick = (groupId) => {
// //     navigate(`/group/${groupId}`);
// //   };
// //   const handleDeleteGroup = async (groupId) => {
// //     const confirmDelete = window.confirm(
// //       "Are you sure you want to delete this group and all its data?"
// //     );
// //     if (!confirmDelete) return;

// //     try {
// //       await deleteDoc(doc(db, "sevakGroups", groupId));
// //       setGroups((prev) => prev.filter((group) => group.groupId !== groupId));
// //       alert("Group deleted successfully.");
// //     } catch (error) {
// //       console.error("Error deleting group:", error);
// //       alert("Failed to delete group.");
// //     }
// //   };

// //   return (
// //     <div className="container mt-4">
// //       <h3 className="mb-3">Sevak Groups List</h3>
// //       <table className="table table-striped">
// //         <thead>
// //           <tr>
// //             <th>S.No</th>
// //             <th>Group ID</th>
// //             <th>Group Name</th>
// //             <th>Leader Name</th>
// //             <th>Contact</th>
// //             <th>Total Members</th>
// //             <th>Action</th>
// //             <th>Download PDF1</th>
// //             <th>Edit</th>
// //             <th>Delete</th>
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {groups.map((group, index) => (
// //             <tr key={group.id}>
// //               <td>{index + 1}</td>
// //               <td>{group.groupId}</td>
// //               <td>{group.groupName}</td>
// //               <td>{group.leaderName}</td>
// //               <td>{group.leaderMobile}</td>
// //               <td>{group.totalMembers}</td>
// //               <td>
// //                 <button
// //                   className="btn btn-sm btn-primary me-2"
// //                   onClick={() => handleGroupClick(group.groupId)}
// //                 >
// //                   Open
// //                 </button>
// //               </td>

// //               <td>
// //                 <Button
// //                   variant="outline-primary"
// //                   className="me-3"
// //                   // onClick={() => generateGroupPDF(group)}
// //                   onClick={async () => {
// //                     try {
// //                       const docRef = doc(db, "sevakGroups", group.id); // Use Firestore doc ID
// //                       const docSnap = await getDoc(docRef);
// //                       if (docSnap.exists()) {
// //                         const fullGroupData = docSnap.data();
// //                         fullGroupData.groupId = group.groupId; // Ensure groupId is present
// //                         fullGroupData.groupName = group.groupName;
// //                         await generateGroupPDF(fullGroupData); // ✅ Pass full data
// //                       } else {
// //                         alert("Group data not found.");
// //                       }
// //                     } catch (error) {
// //                       console.error("Error generating PDF:", error);
// //                       alert("Failed to generate PDF.");
// //                     }
// //                   }}
// //                 >
// //                   Download PDF
// //                 </Button>
// //               </td>

// //               <td>
// //                 <Button
// //                   variant="outline-warning"
// //                   onClick={() => {
// //                     setSelectedGroup(group);
// //                     setConfirmEditInput("");

// //                     setEditGroupData({
// //                       groupName: group.groupName,
// //                       location: group.location,
// //                       mobile: group.leaderMobile,
// //                       imageFolderPath: group.imageFolderPath || "",
// //                     });

// //                     setShowEditModal(true);
// //                   }}
// //                 >
// //                   ✏️ Edit
// //                 </Button>
// //               </td>

// //               <td>
// //                 <button
// //                   className="btn btn-sm"
// //                   onClick={() => {
// //                     setSelectedGroup(group);
// //                     setConfirmInput("");
// //                     setShowModal(true);
// //                   }}
// //                 >
// //                   X
// //                 </button>
// //               </td>
// //             </tr>
// //           ))}
// //         </tbody>
// //       </table>
// //       {showModal && selectedGroup && (
// //         <div className="modal-backdrop">
// //           <div className="modal-dialog">
// //             <div className="modal-content p-4">
// //               <h5>Confirm Deletion</h5>
// //               <p>
// //                 Do you want to delete <strong>{selectedGroup.groupName}</strong>{" "}
// //                 Group?
// //               </p>
// //               <p>Enter Group Account ID to confirm:</p>
// //               <input
// //                 type="text"
// //                 className="form-control mb-3"
// //                 value={confirmInput}
// //                 onChange={(e) => setConfirmInput(e.target.value)}
// //               />
// //               <div className="d-flex justify-content-end">
// //                 <button
// //                   className="btn btn-secondary me-2"
// //                   onClick={() => setShowModal(false)}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   className="btn btn-danger"
// //                   disabled={confirmInput !== selectedGroup.groupId}
// //                   onClick={async () => {
// //                     try {
// //                       await deleteDoc(doc(db, "sevakGroups", selectedGroup.id));
// //                       setGroups((prev) =>
// //                         prev.filter((g) => g.id !== selectedGroup.id)
// //                       );
// //                       setShowModal(false);
// //                       alert("Group deleted successfully.");
// //                     } catch (error) {
// //                       console.error("Error deleting group:", error);
// //                       alert("Failed to delete group.");
// //                     }
// //                   }}
// //                 >
// //                   Confirm
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {showEditModal && selectedGroup && (
// //         <div className="modal-backdrop">
// //           <div className="modal-dialog">
// //             <div className="modal-content p-4">
// //               <h5>Edit Group Details</h5>
// //               <p>
// //                 Enter Group Account ID (<strong>{selectedGroup.groupId}</strong>) to confirm:
// //               </p>
// //               <input
// //                 type="text"
// //                 className="form-control mb-3"
// //                 value={confirmEditInput}
// //                 onChange={(e) => setConfirmEditInput(e.target.value)}
// //               />

// //               {confirmEditInput === selectedGroup.groupId && (
// //                 <>
// //                   <div className="mb-2">
// //                     <label>Group Name</label>
// //                     <input
// //                       type="text"
// //                       className="form-control"
// //                       value={editGroupData.groupName}
// //                       onChange={(e) =>
// //                         setEditGroupData((prev) => ({
// //                           ...prev,
// //                           groupName: e.target.value,
// //                         }))
// //                       }
// //                     />
// //                   </div>
// //                   {/* <div className="mb-2">
// //               <label>Location</label>
// //               <input
// //                 type="text"
// //                 className="form-control"
// //                 value={editGroupData.location}
// //                 onChange={(e) =>
// //                   setEditGroupData((prev) => ({
// //                     ...prev,
// //                     location: e.target.value,
// //                   }))
// //                 }
// //               />
// //             </div> */}
// //                   <div className="mb-2">
// //                     <label>Mobile</label>
// //                     <input
// //                       type="text"
// //                       className="form-control"
// //                       value={editGroupData.mobile}
// //                       onChange={(e) =>
// //                         setEditGroupData((prev) => ({
// //                           ...prev,
// //                           mobile: e.target.value,
// //                         }))
// //                       }
// //                     />
// //                   </div>


// //                   <div className="mb-2">
// //                     <label>Image Folder Path</label>
// //                     <input
// //                       type="text"
// //                       className="form-control"
// //                       value={editGroupData.imageFolderPath || ""}
// //                       placeholder={editGroupData.imageFolderPath ? "" : "No path set yet"}
// //                       onChange={(e) =>
// //                         setEditGroupData((prev) => ({
// //                           ...prev,
// //                           imageFolderPath: e.target.value,
// //                         }))
// //                       }
// //                     />
// //                   </div>

// //                 </>



// //               )}

// //               <div className="d-flex justify-content-end mt-3">
// //                 <button
// //                   className="btn btn-secondary me-2"
// //                   onClick={() => setShowEditModal(false)}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   className="btn btn-success"
// //                   disabled={confirmEditInput !== selectedGroup.groupId}
// //                   onClick={async () => {
// //                     try {
// //                       const groupRef = doc(db, "sevakGroups", selectedGroup.id);
// //                       await updateDoc(groupRef, {
// //                         groupName: editGroupData.groupName,
// //                         // location: editGroupData.location,
// //                         mobile: editGroupData.mobile,
// //                         imageFolderPath: editGroupData.imageFolderPath,
// //                       });

// //                       setGroups((prev) =>
// //                         prev.map((g) =>
// //                           g.id === selectedGroup.id
// //                             ? {
// //                               ...g,
// //                               groupName: editGroupData.groupName,
// //                               location: editGroupData.station || "no",
// //                               leaderMobile: editGroupData.mobile,
// //                               imageFolderPath: editGroupData.imageFolderPath,
// //                             }
// //                             : g
// //                         )
// //                       );

// //                       setShowEditModal(false);
// //                       alert("Group updated successfully.");
// //                     } catch (error) {
// //                       console.error("Error updating group:", error);
// //                       alert("Failed to update group.");
// //                     }
// //                   }}
// //                 >
// //                   Save Changes
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //     </div>
// //   );
// // };

// // export default SevakListGroup;

// // SevakListGroup.jsx
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   doc,
//   collection,
//   getDocs,
//   deleteDoc,
//   getDoc,
//   updateDoc,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import "./SevakListGroup.css";
// import generateGroupPDF from "./GroupMembersPDF";
// import { Button } from "react-bootstrap";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { query, where } from "firebase/firestore";
// import * as XLSX from "xlsx"; // <-- for Excel import

// const SevakListGroup = () => {
//   const [groups, setGroups] = useState([]);
//   const navigate = useNavigate();
//   const [showModal, setShowModal] = useState(false);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [confirmInput, setConfirmInput] = useState("");
//   const [user, setUser] = useState(null);

//   const [showEditModal, setShowEditModal] = useState(false);
//   const [confirmEditInput, setConfirmEditInput] = useState("");
//   const [editGroupData, setEditGroupData] = useState({
//     groupName: "",
//     location: "",
//     mobile: "",
//   });

//   // Local state for per-row importing indicator
//   const [importingForGroupId, setImportingForGroupId] = useState(null);

//   // ----------------- Helpers for Excel Bulk Import -----------------
//   const DEFAULT_NEAREST_TTD = "SV Temple, Jubilee Hills, Hyderabad, Chennai";

//   const REQUIRED_HEADERS = ["AdharNumber", "sevakName", "dob"];
//   const TEMPLATE_HEADERS = [
//     "AdharNumber",
//     "sevakName",
//     "surName",
//     "fatherOrSpouseName",
//     "dob", // accepts YYYY-MM-DD, DD/MM/YYYY, or Excel date
//     "mobileNo",
//     "email",
//     "qualification",
//     "profession",
//     "specialisation",
//     "placeOfWork",
//     "country",
//     "state",
//     "district",
//     "city",
//     "street",
//     "doorNo",
//     "pincode",
//     "nearestTtdTemple",
//     "mentallyFit",
//     "physicallyFit",
//   ];

//   const toTwo = (n) => String(n).padStart(2, "0");

//   const formatDOB_DDMMYYYY = (date) => {
//     const d = new Date(date);
//     if (isNaN(d.getTime())) return "";
//     return `${toTwo(d.getDate())}/${toTwo(d.getMonth() + 1)}/${d.getFullYear()}`;
//   };

//   const excelSerialToDate = (serial) => {
//     const utc_days = Math.floor(serial - 25569);
//     const utc_value = utc_days * 86400;
//     const date_info = new Date(utc_value * 1000);
//     const fractional_day = serial - Math.floor(serial) + 1e-7;
//     let total_seconds = Math.floor(86400 * fractional_day);
//     const seconds = total_seconds % 60;
//     total_seconds -= seconds;
//     const hours = Math.floor(total_seconds / (60 * 60));
//     const minutes = Math.floor(total_seconds / 60) % 60;
//     date_info.setHours(hours, minutes, seconds);
//     return date_info;
//   };

//   const normalizeDOBToDDMMYYYY = (value) => {
//     if (value == null || value === "") return "";
//     if (typeof value === "number") {
//       return formatDOB_DDMMYYYY(excelSerialToDate(value));
//     }
//     if (typeof value === "string") {
//       const v = value.trim();
//       if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
//         const [y, m, d] = v.split("-");
//         return `${d}/${m}/${y}`;
//       }
//       if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) return v;
//       const parsed = new Date(v);
//       if (!isNaN(parsed.getTime())) return formatDOB_DDMMYYYY(parsed);
//       return "";
//     }
//     return "";
//   };

//   const calcAgeFromDDMMYYYY = (dobDDMMYYYY) => {
//     if (!dobDDMMYYYY) return "";
//     const [d, m, y] = dobDDMMYYYY.split("/").map((n) => parseInt(n, 10));
//     const birth = new Date(y, m - 1, d);
//     if (isNaN(birth.getTime())) return "";
//     const today = new Date();
//     let age = today.getFullYear() - birth.getFullYear();
//     const mDiff = today.getMonth() - birth.getMonth();
//     if (mDiff < 0 || (mDiff === 0 && today.getDate() < birth.getDate())) {
//       age--;
//     }
//     return age;
//   };

//   const toBoolean = (val, def = true) => {
//     if (val == null || val === "") return def;
//     if (typeof val === "boolean") return val;
//     const s = String(val).trim().toLowerCase();
//     return ["true", "yes", "y", "1"].includes(s);
//   };

//   const validateHeaders = (headers) => {
//     const set = new Set(headers.map((h) => String(h || "").trim()));
//     for (const r of REQUIRED_HEADERS) if (!set.has(r)) return false;
//     return true;
//   };

//   const parseExcelToMembers = (wb) => {
//     const ws = wb.Sheets[wb.SheetNames[0]];
//     const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
//     if (rows.length < 2) {
//       throw new Error("The Excel file is empty.");
//     }
//     const headers = rows[0].map((h) => String(h).trim());
//     if (!validateHeaders(headers)) {
//       throw new Error(`Invalid headers. Required: ${REQUIRED_HEADERS.join(", ")}`);
//     }
//     const body = rows.slice(1);

//     const parsed = body
//       .map((r) => {
//         const obj = {};
//         headers.forEach((h, i) => (obj[h] = r[i]));
//         const dob = normalizeDOBToDDMMYYYY(obj.dob);
//         const age = calcAgeFromDDMMYYYY(dob);
//         return {
//           AdharNumber: String(obj.AdharNumber || "").trim(),
//           sevakName: String(obj.sevakName || "").trim(),
//           surName: String(obj.surName || "").trim(),
//           fatherOrSpouseName: String(obj.fatherOrSpouseName || "").trim(),
//           dob,
//           age,
//           mobileNo: String(obj.mobileNo || "").trim(),
//           email: String(obj.email || "").trim(),
//           qualification: String(obj.qualification || "").trim(),
//           profession: String(obj.profession || "").trim(),
//           specialisation: String(obj.specialisation || "").trim(),
//           placeOfWork: String(obj.placeOfWork || "").trim(),
//           country: String(obj.country || "").trim(),
//           state: String(obj.state || "").trim(),
//           district: String(obj.district || "").trim(),
//           city: String(obj.city || "").trim(),
//           street: String(obj.street || "").trim(),
//           doorNo: String(obj.doorNo || "").trim(),
//           pincode: String(obj.pincode || "").trim(),
//           nearestTtdTemple: String(obj.nearestTtdTemple || DEFAULT_NEAREST_TTD).trim(),
//           mentallyFit: toBoolean(obj.mentallyFit, true),
//           physicallyFit: toBoolean(obj.physicallyFit, true),
//           profilePicBase64: "", // images to be added later
//         };
//       })
//       .filter((m) => m.AdharNumber && m.sevakName && m.dob);

//     return { headers, members: parsed };
//   };

//   // ----------------- Auth -----------------
//   useEffect(() => {
//     const auth = getAuth();
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       if (currentUser) setUser(currentUser);
//       else setUser(null);
//     });
//     return () => unsubscribe();
//   }, []);

//   // ----------------- Fetch Groups -----------------
//   useEffect(() => {
//     const fetchGroups = async () => {
//       if (!user) return;
//       try {
//         const groupsRef = collection(db, "sevakGroups");
//         let q;
//         if (user.role?.toLowerCase() === "admin") {
//           q = query(groupsRef);
//         } else {
//           q = query(groupsRef, where("createdBy.uid", "==", user.uid));
//         }
//         const querySnapshot = await getDocs(q);
//         const groupList = querySnapshot.docs.map((docSnap) => {
//           const data = docSnap.data();
//           const leader = data.members?.find(
//             (m) => m.designation?.toLowerCase() === "leader"
//           );
//           return {
//             id: docSnap.id,
//             groupId: data.accountId || data.groupId,
//             groupName: data.groupName,
//             station: data.station,
//             leaderName: leader?.name || data.leaderName || "Not Assigned",
//             leaderMobile: leader?.mobile || data.mobile || "-",
//             totalMembers: data.members?.length || 0,
//             imageFolderPath: data.imageFolderPath,
//             location: data.location,
//           };
//         });
//         setGroups(groupList);
//       } catch (error) {
//         console.error("Error fetching groups:", error);
//       }
//     };
//     fetchGroups();
//   }, [user]);

//   // ----------------- Navigation -----------------
//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

//   // ----------------- Delete Group -----------------
//   const handleDeleteGroup = async (groupId) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this group and all its data?"
//     );
//     if (!confirmDelete) return;
//     try {
//       await deleteDoc(doc(db, "sevakGroups", groupId));
//       setGroups((prev) => prev.filter((group) => group.groupId !== groupId));
//       alert("Group deleted successfully.");
//     } catch (error) {
//       console.error("Error deleting group:", error);
//       alert("Failed to delete group.");
//     }
//   };

//   // ----------------- Excel Upload (per-row) -----------------
//   const handleExcelUploadForGroup = async (file, group) => {
//     if (!file || !group?.id) return;
//     setImportingForGroupId(group.id);
//     try {
//       const data = await file.arrayBuffer();
//       const wb = XLSX.read(data, { type: "array" });
//       const { members: parsed } = parseExcelToMembers(wb);

//       // Load fresh group
//       const groupRef = doc(db, "sevakGroups", group.id);
//       const snap = await getDoc(groupRef);
//       if (!snap.exists()) throw new Error("Group not found in Firestore.");

//       const docData = snap.data();
//       const existingMembers = Array.isArray(docData.members) ? docData.members : [];
//       const currentCount = existingMembers.length;

//       // Enforce max 15
//       const remainingSlots = 15 - currentCount;
//       if (remainingSlots <= 0) {
//         alert("This group already has 15 members.");
//         return;
//       }

//       // Limit to remaining slots
//       let trimmed = parsed.slice(0, remainingSlots);

//       // Remove duplicates by AdharNumber
//       const existingAdhars = new Set(
//         existingMembers.map((m) => String(m.AdharNumber || "").trim())
//       );
//       trimmed = trimmed.filter((r) => !existingAdhars.has(r.AdharNumber));

//       if (trimmed.length === 0) {
//         alert("No new members to add (duplicates or empty).");
//         return;
//       }

//       // Assign accountId, imageId, designation like SevakForm
//       const toAdd = trimmed.map((r, i) => {
//         const accountId = `${group.id}${currentCount + i + 1}`;
//         const imageId = `${accountId}_image`;
//         const designation = currentCount === 0 && i === 0 ? "teamleader" : "member";
//         return { ...r, accountId, imageId, designation };
//       });

//       const updatedMembers = [...existingMembers, ...toAdd];
//       await updateDoc(groupRef, { members: updatedMembers });

//       // update UI counts
//       setGroups((prev) =>
//         prev.map((g) =>
//           g.id === group.id
//             ? { ...g, totalMembers: updatedMembers.length }
//             : g
//         )
//       );

//       alert(`Imported ${toAdd.length} member(s) successfully.`);
//     } catch (err) {
//       console.error("Import failed:", err);
//       alert(`Failed to import: ${err.message || err.toString()}`);
//     } finally {
//       setImportingForGroupId(null);
//     }
//   };

//   // ----------------- Download Images (as JPEGs) -----------------
//   const dataURLToJpegDataURL = (dataUrl, quality = 0.92) =>
//     new Promise((resolve, reject) => {
//       try {
//         const img = new Image();
//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           canvas.width = img.naturalWidth || img.width;
//           canvas.height = img.naturalHeight || img.height;
//           const ctx = canvas.getContext("2d");
//           ctx.drawImage(img, 0, 0);
//           const jpegUrl = canvas.toDataURL("image/jpeg", quality);
//           resolve(jpegUrl);
//         };
//         img.onerror = reject;
//         img.src = dataUrl;
//       } catch (e) {
//         reject(e);
//       }
//     });

//   const triggerDownload = (href, fileName) => {
//     const a = document.createElement("a");
//     a.href = href;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//   };

//   const handleDownloadImages = async (group) => {
//     try {
//       const groupRef = doc(db, "sevakGroups", group.id);
//       const snap = await getDoc(groupRef);
//       if (!snap.exists()) {
//         alert("Group not found.");
//         return;
//       }
//       const data = snap.data();
//       const members = Array.isArray(data.members) ? data.members : [];
//       const withPics = members.filter((m) => !!m.profilePicBase64);

//       if (withPics.length === 0) {
//         alert("No images available for this group.");
//         return;
//       }

//       // Sequentially convert and download as JPEG
//       for (let i = 0; i < withPics.length; i++) {
//         const m = withPics[i];
//         const base64 = m.profilePicBase64;
//         const jpegDataUrl = await dataURLToJpegDataURL(base64, 0.92);
//         const safeName = (m.sevakName || `member_${i + 1}`).replace(/[^\w-]+/g, "_");
//         const fileName = `${m.accountId || `${group.groupId}_${i + 1}`}_${safeName}.jpeg`;
//         triggerDownload(jpegDataUrl, fileName);
//       }
//     } catch (err) {
//       console.error("Download images failed:", err);
//       alert("Failed to download images.");
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h3 className="mb-3">Sevak Groups List</h3>
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Group ID</th>
//             <th>Group Name</th>
//             <th>Leader Name</th>
//             <th>Contact</th>
//             <th>Total Members</th>
//             <th>Action</th>
//             <th>Download PDF</th>
//             <th>Edit</th>
//             <th>Upload Excel</th> {/* <-- New column BEFORE Delete */}
//             <th>Delete</th>
//           </tr>
//         </thead>
//         <tbody>
//           {groups.map((group, index) => (
//             <tr key={group.id}>
//               <td>{index + 1}</td>
//               <td>{group.groupId}</td>
//               <td>{group.groupName}</td>
//               <td>{group.leaderName}</td>
//               <td>{group.leaderMobile}</td>
//               <td>{group.totalMembers}</td>
//               <td>
//                 <button
//                   className="btn btn-sm btn-primary me-2"
//                   onClick={() => handleGroupClick(group.groupId)}
//                 >
//                   Open
//                 </button>
//               </td>

//               <td>
//                 <div className="d-flex align-items-center gap-2">
//                   <Button
//                     variant="outline-primary"
//                     className="me-2"
//                     onClick={async () => {
//                       try {
//                         const docRef = doc(db, "sevakGroups", group.id); // Use Firestore doc ID
//                         const docSnap = await getDoc(docRef);
//                         if (docSnap.exists()) {
//                           const fullGroupData = docSnap.data();
//                           fullGroupData.groupId = group.groupId;
//                           fullGroupData.groupName = group.groupName;
//                           await generateGroupPDF(fullGroupData);
//                         } else {
//                           alert("Group data not found.");
//                         }
//                       } catch (error) {
//                         console.error("Error generating PDF:", error);
//                         alert("Failed to generate PDF.");
//                       }
//                     }}
//                   >
//                     Download PDF
//                   </Button>

//                   {/* New Download Images Button */}
//                   <Button
//                     variant="outline-success"
//                     onClick={() => handleDownloadImages(group)}
//                   >
//                     Download Images
//                   </Button>
//                 </div>
//               </td>

//               <td>
//                 <Button
//                   variant="outline-warning"
//                   onClick={() => {
//                     setSelectedGroup(group);
//                     setConfirmEditInput("");
//                     setEditGroupData({
//                       groupName: group.groupName,
//                       location: group.location,
//                       mobile: group.leaderMobile,
//                       imageFolderPath: group.imageFolderPath || "",
//                     });
//                     setShowEditModal(true);
//                   }}
//                 >
//                   ✏️ Edit
//                 </Button>
//               </td>

//               {/* New Upload Excel column (before Delete) */}
//               <td>
//                 <label className="btn btn-outline-secondary btn-sm mb-0">
//                   {importingForGroupId === group.id ? "Importing..." : "Upload Excel"}
//                   <input
//                     type="file"
//                     accept=".xlsx,.xls"
//                     style={{ display: "none" }}
//                     disabled={importingForGroupId === group.id}
//                     onChange={(e) => {
//                       const file = e.target.files?.[0];
//                       e.target.value = ""; // reset input
//                       if (file) handleExcelUploadForGroup(file, group);
//                     }}
//                   />
//                 </label>
//               </td>

//               <td>
//                 <button
//                   className="btn btn-sm"
//                   onClick={() => {
//                     setSelectedGroup(group);
//                     setConfirmInput("");
//                     setShowModal(true);
//                   }}
//                 >
//                   X
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Delete Confirmation Modal */}
//       {showModal && selectedGroup && (
//         <div className="modal-backdrop">
//           <div className="modal-dialog">
//             <div className="modal-content p-4">
//               <h5>Confirm Deletion</h5>
//               <p>
//                 Do you want to delete <strong>{selectedGroup.groupName}</strong> Group?
//               </p>
//               <p>Enter Group Account ID to confirm:</p>
//               <input
//                 type="text"
//                 className="form-control mb-3"
//                 value={confirmInput}
//                 onChange={(e) => setConfirmInput(e.target.value)}
//               />
//               <div className="d-flex justify-content-end">
//                 <button
//                   className="btn btn-secondary me-2"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-danger"
//                   disabled={confirmInput !== selectedGroup.groupId}
//                   onClick={async () => {
//                     try {
//                       await deleteDoc(doc(db, "sevakGroups", selectedGroup.id));
//                       setGroups((prev) => prev.filter((g) => g.id !== selectedGroup.id));
//                       setShowModal(false);
//                       alert("Group deleted successfully.");
//                     } catch (error) {
//                       console.error("Error deleting group:", error);
//                       alert("Failed to delete group.");
//                     }
//                   }}
//                 >
//                   Confirm
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Group Modal */}
//       {showEditModal && selectedGroup && (
//         <div className="modal-backdrop">
//           <div className="modal-dialog">
//             <div className="modal-content p-4">
//               <h5>Edit Group Details</h5>
//               <p>
//                 Enter Group Account ID (<strong>{selectedGroup.groupId}</strong>) to confirm:
//               </p>
//               <input
//                 type="text"
//                 className="form-control mb-3"
//                 value={confirmEditInput}
//                 onChange={(e) => setConfirmEditInput(e.target.value)}
//               />

//               {confirmEditInput === selectedGroup.groupId && (
//                 <>
//                   <div className="mb-2">
//                     <label>Group Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={editGroupData.groupName}
//                       onChange={(e) =>
//                         setEditGroupData((prev) => ({
//                           ...prev,
//                           groupName: e.target.value,
//                         }))
//                       }
//                     />
//                   </div>
//                   <div className="mb-2">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={editGroupData.mobile}
//                       onChange={(e) =>
//                         setEditGroupData((prev) => ({
//                           ...prev,
//                           mobile: e.target.value,
//                         }))
//                       }
//                     />
//                   </div>

//                   <div className="mb-2">
//                     <label>Image Folder Path</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={editGroupData.imageFolderPath || ""}
//                       placeholder={editGroupData.imageFolderPath ? "" : "No path set yet"}
//                       onChange={(e) =>
//                         setEditGroupData((prev) => ({
//                           ...prev,
//                           imageFolderPath: e.target.value,
//                         }))
//                       }
//                     />
//                   </div>
//                 </>
//               )}

//               <div className="d-flex justify-content-end mt-3">
//                 <button
//                   className="btn btn-secondary me-2"
//                   onClick={() => setShowEditModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-success"
//                   disabled={confirmEditInput !== selectedGroup.groupId}
//                   onClick={async () => {
//                     try {
//                       const groupRef = doc(db, "sevakGroups", selectedGroup.id);
//                       await updateDoc(groupRef, {
//                         groupName: editGroupData.groupName,
//                         mobile: editGroupData.mobile,
//                         imageFolderPath: editGroupData.imageFolderPath,
//                       });

//                       setGroups((prev) =>
//                         prev.map((g) =>
//                           g.id === selectedGroup.id
//                             ? {
//                               ...g,
//                               groupName: editGroupData.groupName,
//                               location: editGroupData.station || "no",
//                               leaderMobile: editGroupData.mobile,
//                               imageFolderPath: editGroupData.imageFolderPath,
//                             }
//                             : g
//                         )
//                       );

//                       setShowEditModal(false);
//                       alert("Group updated successfully.");
//                     } catch (error) {
//                       console.error("Error updating group:", error);
//                       alert("Failed to update group.");
//                     }
//                   }}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SevakListGroup;

// SevakListGroup.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  doc,
  collection,
  getDocs,
  deleteDoc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import "./SevakListGroup.css";
import generateGroupPDF from "./GroupMembersPDF";
import { Button } from "react-bootstrap";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { query, where } from "firebase/firestore";
import * as XLSX from "xlsx"; // Excel import
import JSZip from "jszip"; // ZIP
import { saveAs } from "file-saver"; // Save ZIP

const SevakListGroup = () => {
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [confirmInput, setConfirmInput] = useState("");
  const [user, setUser] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [confirmEditInput, setConfirmEditInput] = useState("");
  const [editGroupData, setEditGroupData] = useState({
    groupName: "",
    location: "",
    mobile: "",
  });

  // Local state for per-row importing indicator
  const [importingForGroupId, setImportingForGroupId] = useState(null);

  // ----------------- Helpers for Excel Bulk Import -----------------
  const DEFAULT_NEAREST_TTD = "SV Temple, Jubilee Hills, Hyderabad, Chennai";

  const REQUIRED_HEADERS = ["AdharNumber", "sevakName", "dob"];
  const TEMPLATE_HEADERS = [
    "AdharNumber",
    "sevakName",
    "surName",
    "fatherOrSpouseName",
    "dob", // accepts YYYY-MM-DD, DD/MM/YYYY, or Excel date
    "mobileNo",
    "email",
    "qualification",
    "profession",
    "specialisation",
    "placeOfWork",
    "country",
    "state",
    "district",
    "city",
    "street",
    "doorNo",
    "pincode",
    "nearestTtdTemple",
    "mentallyFit",
    "physicallyFit",
  ];

  const toTwo = (n) => String(n).padStart(2, "0");

  const formatDOB_DDMMYYYY = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return `${toTwo(d.getDate())}/${toTwo(d.getMonth() + 1)}/${d.getFullYear()}`;
  };

  const excelSerialToDate = (serial) => {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    const fractional_day = serial - Math.floor(serial) + 1e-7;
    let total_seconds = Math.floor(86400 * fractional_day);
    const seconds = total_seconds % 60;
    total_seconds -= seconds;
    const hours = Math.floor(total_seconds / (60 * 60));
    const minutes = Math.floor(total_seconds / 60) % 60;
    date_info.setHours(hours, minutes, seconds);
    return date_info;
  };

  const normalizeDOBToDDMMYYYY = (value) => {
    if (value == null || value === "") return "";
    if (typeof value === "number") {
      return formatDOB_DDMMYYYY(excelSerialToDate(value));
    }
    if (typeof value === "string") {
      const v = value.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        const [y, m, d] = v.split("-");
        return `${d}/${m}/${y}`;
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) return v;
      const parsed = new Date(v);
      if (!isNaN(parsed.getTime())) return formatDOB_DDMMYYYY(parsed);
      return "";
    }
    return "";
  };

  const calcAgeFromDDMMYYYY = (dobDDMMYYYY) => {
    if (!dobDDMMYYYY) return "";
    const [d, m, y] = dobDDMMYYYY.split("/").map((n) => parseInt(n, 10));
    const birth = new Date(y, m - 1, d);
    if (isNaN(birth.getTime())) return "";
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const mDiff = today.getMonth() - birth.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const toBoolean = (val, def = true) => {
    if (val == null || val === "") return def;
    if (typeof val === "boolean") return val;
    const s = String(val).trim().toLowerCase();
    return ["true", "yes", "y", "1"].includes(s);
  };

  const validateHeaders = (headers) => {
    const set = new Set(headers.map((h) => String(h || "").trim()));
    for (const r of REQUIRED_HEADERS) if (!set.has(r)) return false;
    return true;
  };

  const parseExcelToMembers = (wb) => {
    const ws = wb.Sheets[wb.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
    if (rows.length < 2) {
      throw new Error("The Excel file is empty.");
    }
    const headers = rows[0].map((h) => String(h).trim());
    if (!validateHeaders(headers)) {
      throw new Error(`Invalid headers. Required: ${REQUIRED_HEADERS.join(", ")}`);
    }
    const body = rows.slice(1);

    const parsed = body
      .map((r) => {
        const obj = {};
        headers.forEach((h, i) => (obj[h] = r[i]));
        const dob = normalizeDOBToDDMMYYYY(obj.dob);
        const age = calcAgeFromDDMMYYYY(dob);
        return {
          AdharNumber: String(obj.AdharNumber || "").trim(),
          sevakName: String(obj.sevakName || "").trim(),
          surName: String(obj.surName || "").trim(),
          fatherOrSpouseName: String(obj.fatherOrSpouseName || "").trim(),
          dob,
          age,
          mobileNo: String(obj.mobileNo || "").trim(),
          email: String(obj.email || "").trim(),
          qualification: String(obj.qualification || "").trim(),
          profession: String(obj.profession || "").trim(),
          specialisation: String(obj.specialisation || "").trim(),
          placeOfWork: String(obj.placeOfWork || "").trim(),
          country: String(obj.country || "").trim(),
          state: String(obj.state || "").trim(),
          district: String(obj.district || "").trim(),
          city: String(obj.city || "").trim(),
          street: String(obj.street || "").trim(),
          doorNo: String(obj.doorNo || "").trim(),
          pincode: String(obj.pincode || "").trim(),
          nearestTtdTemple: String(obj.nearestTtdTemple || DEFAULT_NEAREST_TTD).trim(),
          mentallyFit: toBoolean(obj.mentallyFit, true),
          physicallyFit: toBoolean(obj.physicallyFit, true),
          profilePicBase64: "", // images to be added later
        };
      })
      .filter((m) => m.AdharNumber && m.sevakName && m.dob);

    return { headers, members: parsed };
  };

  // ----------------- Auth -----------------
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) setUser(currentUser);
      else setUser(null);
    });
    return () => unsubscribe();
  }, []);

  // ----------------- Fetch Groups -----------------
  useEffect(() => {
    const fetchGroups = async () => {
      if (!user) return;
      try {
        const groupsRef = collection(db, "sevakGroups");
        let q;
        if (user.role?.toLowerCase() === "admin") {
          q = query(groupsRef);
        } else {
          q = query(groupsRef, where("createdBy.uid", "==", user.uid));
        }
        const querySnapshot = await getDocs(q);
        const groupList = querySnapshot.docs.map((docSnap) => {
          const data = docSnap.data();
          const leader = data.members?.find(
            (m) => m.designation?.toLowerCase() === "leader"
          );
          return {
            id: docSnap.id,
            groupId: data.accountId || data.groupId,
            groupName: data.groupName,
            station: data.station,
            leaderName: leader?.name || data.leaderName || "Not Assigned",
            leaderMobile: leader?.mobile || data.mobile || "-",
            totalMembers: data.members?.length || 0,
            imageFolderPath: data.imageFolderPath,
            location: data.location,
          };
        });
        setGroups(groupList);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroups();
  }, [user]);

  // ----------------- Navigation -----------------
  const handleGroupClick = (groupId) => {
    navigate(`/group/${groupId}`);
  };

  // ----------------- Delete Group -----------------
  const handleDeleteGroup = async (groupId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this group and all its data?"
    );
    if (!confirmDelete) return;
    try {
      await deleteDoc(doc(db, "sevakGroups", groupId));
      setGroups((prev) => prev.filter((group) => group.groupId !== groupId));
      alert("Group deleted successfully.");
    } catch (error) {
      console.error("Error deleting group:", error);
      alert("Failed to delete group.");
    }
  };

  // ----------------- Excel Upload (per-row) -----------------
  const handleExcelUploadForGroup = async (file, group) => {
    if (!file || !group?.id) return;
    setImportingForGroupId(group.id);
    try {
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data, { type: "array" });
      const { members: parsed } = parseExcelToMembers(wb);

      // Load fresh group
      const groupRef = doc(db, "sevakGroups", group.id);
      const snap = await getDoc(groupRef);
      if (!snap.exists()) throw new Error("Group not found in Firestore.");

      const docData = snap.data();
      const existingMembers = Array.isArray(docData.members) ? docData.members : [];
      const currentCount = existingMembers.length;

      // Enforce max 15
      const remainingSlots = 15 - currentCount;
      if (remainingSlots <= 0) {
        alert("This group already has 15 members.");
        return;
      }

      // Limit to remaining slots
      let trimmed = parsed.slice(0, remainingSlots);

      // Remove duplicates by AdharNumber
      const existingAdhars = new Set(
        existingMembers.map((m) => String(m.AdharNumber || "").trim())
      );
      trimmed = trimmed.filter((r) => !existingAdhars.has(r.AdharNumber));

      if (trimmed.length === 0) {
        alert("No new members to add (duplicates or empty).");
        return;
      }

      // Assign accountId, imageId, designation like SevakForm
      const toAdd = trimmed.map((r, i) => {
        const accountId = `${group.id}${currentCount + i + 1}`;
        const imageId = `${accountId}_image`;
        const designation = currentCount === 0 && i === 0 ? "teamleader" : "member";
        return { ...r, accountId, imageId, designation };
      });

      const updatedMembers = [...existingMembers, ...toAdd];
      await updateDoc(groupRef, { members: updatedMembers });

      // update UI counts
      setGroups((prev) =>
        prev.map((g) =>
          g.id === group.id
            ? { ...g, totalMembers: updatedMembers.length }
            : g
        )
      );

      alert(`Imported ${toAdd.length} member(s) successfully.`);
    } catch (err) {
      console.error("Import failed:", err);
      alert(`Failed to import: ${err.message || err.toString()}`);
    } finally {
      setImportingForGroupId(null);
    }
  };

  // ----------------- Download Images (ZIP, JPEG, serial as index+1) -----------------
  const dataURLToJPEGBlob = (dataUrl, quality = 0.92) =>
    new Promise((resolve, reject) => {
      try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 512;
          canvas.height = img.naturalHeight || img.height || 512;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          canvas.toBlob(
            (blob) => {
              if (blob) resolve(blob);
              else reject(new Error("Failed to create JPEG blob"));
            },
            "image/jpeg",
            quality
          );
        };
        img.onerror = (e) => reject(e);
        img.src = dataUrl;
      } catch (e) {
        reject(e);
      }
    });

  const handleDownloadImagesZip = async (group) => {
    try {
      const groupRef = doc(db, "sevakGroups", group.id);
      const snap = await getDoc(groupRef);
      if (!snap.exists()) {
        alert("Group not found.");
        return;
      }

      const data = snap.data();
      const members = Array.isArray(data.members) ? data.members : [];

      // Build ZIP following Firestore order; filename = index+1.jpeg
      const zip = new JSZip();
      let addedCount = 0;

      for (let idx = 0; idx < members.length; idx++) {
        const m = members[idx];
        const base64 = m?.profilePicBase64;
        if (!base64) continue;

        // Convert to JPEG Blob
        const jpegBlob = await dataURLToJPEGBlob(base64, 0.92);
        const fileName = `${idx + 1}.jpeg`; // SERIAL = array index + 1
        zip.file(fileName, jpegBlob);
        addedCount++;
      }

      if (addedCount === 0) {
        alert("No images available for this group.");
        return;
      }

      const content = await zip.generateAsync({ type: "blob" });
      const zipName = `${group.groupId || group.id}_images.zip`;
      saveAs(content, zipName);
    } catch (err) {
      console.error("ZIP download failed:", err);
      alert("Failed to download ZIP with images.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Sevak Groups List</h3>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Group ID</th>
            <th>Group Name</th>
            <th>Leader Name</th>
            <th>Contact</th>
            <th>Total Members</th>
            <th>Action</th>
            <th>Download PDF</th>
            <th>Edit</th>
            <th>Upload Excel</th> {/* <-- New column BEFORE Delete */}
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group, index) => (
            <tr key={group.id}>
              <td>{index + 1}</td>
              <td>{group.groupId}</td>
              <td>{group.groupName}</td>
              <td>{group.leaderName}</td>
              <td>{group.leaderMobile}</td>
              <td>{group.totalMembers}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => handleGroupClick(group.groupId)}
                >
                  Open
                </button>
              </td>

              <td>
                <div className="d-flex align-items-center gap-2">
                  <Button
                    variant="outline-primary"
                    className="me-2"
                    onClick={async () => {
                      try {
                        const docRef = doc(db, "sevakGroups", group.id);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                          const fullGroupData = docSnap.data();
                          fullGroupData.groupId = group.groupId;
                          fullGroupData.groupName = group.groupName;
                          await generateGroupPDF(fullGroupData);
                        } else {
                          alert("Group data not found.");
                        }
                      } catch (error) {
                        console.error("Error generating PDF:", error);
                        alert("Failed to generate PDF.");
                      }
                    }}
                  >
                    Download PDF
                  </Button>

                  {/* New ZIP Download Button */}
                  <Button
                    variant="outline-success"
                    onClick={() => handleDownloadImagesZip(group)}
                  >
                    Download Images
                  </Button>
                </div>
              </td>

              <td>
                <Button
                  variant="outline-warning"
                  onClick={() => {
                    setSelectedGroup(group);
                    setConfirmEditInput("");
                    setEditGroupData({
                      groupName: group.groupName,
                      location: group.location,
                      mobile: group.leaderMobile,
                      imageFolderPath: group.imageFolderPath || "",
                    });
                    setShowEditModal(true);
                  }}
                >
                  ✏️ Edit
                </Button>
              </td>

              {/* Upload Excel column (before Delete) */}
              <td>
                <label className="btn btn-outline-secondary btn-sm mb-0">
                  {importingForGroupId === group.id ? "Importing..." : "Upload Excel"}
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    style={{ display: "none" }}
                    disabled={importingForGroupId === group.id}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      e.target.value = ""; // reset input
                      if (file) handleExcelUploadForGroup(file, group);
                    }}
                  />
                </label>
              </td>

              <td>
                <button
                  className="btn btn-sm"
                  onClick={() => {
                    setSelectedGroup(group);
                    setConfirmInput("");
                    setShowModal(true);
                  }}
                >
                  X
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Delete Confirmation Modal */}
      {showModal && selectedGroup && (
        <div className="modal-backdrop">
          <div className="modal-dialog">
            <div className="modal-content p-4">
              <h5>Confirm Deletion</h5>
              <p>
                Do you want to delete <strong>{selectedGroup.groupName}</strong> Group?
              </p>
              <p>Enter Group Account ID to confirm:</p>
              <input
                type="text"
                className="form-control mb-3"
                value={confirmInput}
                onChange={(e) => setConfirmInput(e.target.value)}
              />
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  disabled={confirmInput !== selectedGroup.groupId}
                  onClick={async () => {
                    try {
                      await deleteDoc(doc(db, "sevakGroups", selectedGroup.id));
                      setGroups((prev) => prev.filter((g) => g.id !== selectedGroup.id));
                      setShowModal(false);
                      alert("Group deleted successfully.");
                    } catch (error) {
                      console.error("Error deleting group:", error);
                      alert("Failed to delete group.");
                    }
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Group Modal */}
      {showEditModal && selectedGroup && (
        <div className="modal-backdrop">
          <div className="modal-dialog">
            <div className="modal-content p-4">
              <h5>Edit Group Details</h5>
              <p>
                Enter Group Account ID (<strong>{selectedGroup.groupId}</strong>) to confirm:
              </p>
              <input
                type="text"
                className="form-control mb-3"
                value={confirmEditInput}
                onChange={(e) => setConfirmEditInput(e.target.value)}
              />

              {confirmEditInput === selectedGroup.groupId && (
                <>
                  <div className="mb-2">
                    <label>Group Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editGroupData.groupName}
                      onChange={(e) =>
                        setEditGroupData((prev) => ({
                          ...prev,
                          groupName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="mb-2">
                    <label>Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editGroupData.mobile}
                      onChange={(e) =>
                        setEditGroupData((prev) => ({
                          ...prev,
                          mobile: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="mb-2">
                    <label>Image Folder Path</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editGroupData.imageFolderPath || ""}
                      placeholder={editGroupData.imageFolderPath ? "" : "No path set yet"}
                      onChange={(e) =>
                        setEditGroupData((prev) => ({
                          ...prev,
                          imageFolderPath: e.target.value,
                        }))
                      }
                    />
                  </div>
                </>
              )}

              <div className="d-flex justify-content-end mt-3">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  disabled={confirmEditInput !== selectedGroup.groupId}
                  onClick={async () => {
                    try {
                      const groupRef = doc(db, "sevakGroups", selectedGroup.id);
                      await updateDoc(groupRef, {
                        groupName: editGroupData.groupName,
                        mobile: editGroupData.mobile,
                        imageFolderPath: editGroupData.imageFolderPath,
                      });

                      setGroups((prev) =>
                        prev.map((g) =>
                          g.id === selectedGroup.id
                            ? {
                              ...g,
                              groupName: editGroupData.groupName,
                              location: editGroupData.station || "no",
                              leaderMobile: editGroupData.mobile,
                              imageFolderPath: editGroupData.imageFolderPath,
                            }
                            : g
                        )
                      );

                      setShowEditModal(false);
                      alert("Group updated successfully.");
                    } catch (error) {
                      console.error("Error updating group:", error);
                      alert("Failed to update group.");
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SevakListGroup;
